import { AddCircle, Close, CloudUpload, Save } from '@mui/icons-material'
import { LoadingButton } from '@mui/lab';
import { Button, Card, CardMedia, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Tooltip } from '@mui/material';
import ArgonBox from 'components/ArgonBox';
import ArgonButton from 'components/ArgonButton'
import ArgonTypography from 'components/ArgonTypography';
import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import ArgonInput from 'components/ArgonInput';
import styled from '@emotion/styled';
import { postSubmit } from 'global/postFunc';
import userStore from 'store/userStore';
import { CustomDescrypt } from 'global/func';

const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

const getTanggal = () => {
    let date = new Date().toLocaleDateString("fr-CA", { year: "numeric", month: "2-digit", day: "2-digit" })
    // let day = date.getDate();
    return date;
}

const ImagePreview = ({ gambar, index, removeImage }) => {
    return (
        <Card
            sx={{
                height: '300px',
                width: '100%',
            }}
        >
            <CardMedia
                component="img"
                image={URL.createObjectURL(gambar)}
                alt="Dokumentasi"
                sx={{
                    m: 0,
                    height: '100%',
                    width: '100%',
                    objectFit: 'contain'
                }}
            />

            <Tooltip title="hapus">
                <IconButton
                    aria-label="delete"
                    sx={{
                        position: 'absolute',
                        top: 0,
                        right: 0
                    }}
                    onClick={() => removeImage(index)}
                >
                    <Close color='error' />
                </IconButton>
            </Tooltip>
        </Card>
    )
}

const TambahMonev = ({
    komponenData,
    updating,
    setUpdating
}) => {
    const { user, addReq } = userStore(state => ({ user: state.user, addReq: state.addReq }));
    const decryptedUser = (user === null || user === undefined || user === '') ? "" : JSON.parse(CustomDescrypt(user));

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [saving, setSaving] = useState(false)

    const [tanggal, setTanggal] = useState('')
    const [uraian, setUraian] = useState('')
    const [listGambar, setListGambar] = useState([])

    useEffect(() => {
        if (open) {
            setTanggal(getTanggal)
            console.log(tanggal);
            console.log(komponenData);
            setListGambar([])
            setTanggal('')
            setUraian('')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    const submit = (e) => {
        e.preventDefault();
        let formData = {
            // id_sub_rincian_objek: `${parentData.id}-${subRincianObjekBl.kd_sub_rincian_objek}`,
            'id_komponen': komponenData.id,
            'tanggal': tanggal,
            'uraian': uraian,
            'kd_pd': komponenData.kd_pd,
            'gambar[]': listGambar,
            'ta': komponenData.ta
        };
        // console.log(formData);
        setSaving(true)
        addReq()
        postSubmit(
            '/sa/monev/tambah',
            formData,
            decryptedUser,
            (res) => {
                setSaving(false)
                setOpen(false)
                setUpdating(!updating)
                console.log(res);
            },
            (res) => {
                setSaving(false)
                setOpen(false)
            }
        )
    }

    const loadData = (e) => {
        let gbr = e.target.files[0]
        setListGambar(listGambar => [...listGambar, gbr])
        console.log(gbr);
        // setgbr(e.target.files[0])
    }

    const removeImage = (index) => {
        console.log(index);
        const newArray = [...listGambar.slice(0, index), ...listGambar.slice(index + 1)];
        setListGambar(newArray)
    }

    return (
        <>
            <ArgonButton
                variant='outlined'
                color="info"
                size="small"
                startIcon={<AddCircle />}
                onClick={handleOpen}
            >
                Tambah Monev
            </ArgonButton>
            <Dialog
                open={open}
                maxWidth="md"
                fullWidth
                scroll='paper'
                p={3}
                component='form'
                onSubmit={submit}
            >
                <DialogTitle>
                    <ArgonTypography variant='body2' fontWeight="bold">Input Monev</ArgonTypography>
                </DialogTitle>
                <DialogContent p={3}>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Tanggal
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="date"
                            placeholder="Date"
                            value={tanggal}
                            onChange={(e) => setTanggal(e.target.value)}
                        />
                    </ArgonBox>
                    <ArgonBox mb={1}>
                        <ArgonBox mb={1} ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Uraian
                            </ArgonTypography>
                        </ArgonBox>
                        <ArgonInput
                            type="text"
                            required
                            size="medium"
                            value={uraian}
                            autoComplete='off'
                            onChange={(e) => setUraian(e.target.value)}
                        />
                    </ArgonBox>
                    {
                        listGambar.length > 0 &&
                        <Grid container spacing={2} justifyContent='center' mb={2} mt={2}>
                            {
                                listGambar.map((gambar, index) => (
                                    <Grid item xs={12} sm={6} lg={4} key={index}>
                                        <ImagePreview
                                            gambar={gambar}
                                            index={index}
                                            removeImage={removeImage}
                                        />
                                    </Grid>
                                ))
                            }
                        </Grid>
                    }
                    <ArgonBox display="flex" justifyContent='center'>
                        <ArgonBox ml={0.5}>
                            <ArgonTypography component="label" variant="caption" fontWeight="bold">
                                Dokumentasi
                            </ArgonTypography>
                        </ArgonBox>
                    </ArgonBox>
                    <ArgonBox mb={1} display="flex" justifyContent='center'>
                        <Button
                            component="label"
                            role={undefined}
                            variant="contained"
                            tabIndex={-1}
                            startIcon={<CloudUpload />}
                            size='small'
                        >
                            Upload file
                            <VisuallyHiddenInput
                                type="file"
                                onChange={loadData}
                                accept='image/jpg'
                            />
                        </Button>
                    </ArgonBox>
                </DialogContent>
                <DialogActions>
                    <Grid container spacing={2} justifyContent='flex-end' px={2} mb={2}>
                        <Grid item>
                            <ArgonButton color='info' variant='outlined' size="small" startIcon={<Close />} onClick={handleClose}>Batal</ArgonButton>
                        </Grid>
                        <Grid item>
                            <LoadingButton color='info' variant='contained' size="small" startIcon={<Save />} type='submit' loading={saving}>Simpan</LoadingButton>
                        </Grid>
                    </Grid>
                </DialogActions>
            </Dialog>
        </>
    )
}

TambahMonev.propTypes = {
    komponenData: PropTypes.object.isRequired
}

export default TambahMonev